import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from '@/context/AuthContext';
import { can, type Module } from '@/types';
import { LoaderScreen } from '@/components/ui/LoaderScreen';

type Props = {
  children: ReactNode;
  module?: Module;
  action?: 'read' | 'write';
};

export function ProtectedRoute({ children, module, action = 'read' }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoaderScreen />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (module && !can(user.role, module, action)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
